import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface TabFilterOption {
  name: string;
  code: string;
}

@Component({
  selector: 'app-tab-filter',
  templateUrl: './tab-filter.component.html',
  styleUrls: ['./tab-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabFilterComponent {
  @Input() options: TabFilterOption[] = [];

  @Output() filterChange: EventEmitter<any> = new EventEmitter();

  public emitFilterChange(index: number): void {
    this.filterChange.emit(this.options[index].code);
  }
}
